import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import { get } from 'lodash';
import { downloadASQReport } from 'actions/download';
import { enqueueAsqSurveyResultsParentEmailSendout } from 'actions/asq';
import { linkWithParams } from 'routes';
import { getTeachersScores } from 'selectors';
import { showPlayerQuestionModal, showQuestionNotesModal } from 'actions/internal';
import PlayerSurvey from 'components/player/PlayerSurvey';

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    isLoading: getTeachersScores(state),
    location: state.router.location,
    player: state.player.player,
    playerId: get(state.player.player, 'id'),
    survey: state.player.survey,
    download: state.survey.download,
    questionnaires: state.player.questionnaires,
    asqFollowUpParentMessagesEnabled: state.player.survey.result.asqFollowUpParentMessagesEnabled,
    asqSurveyResultsParentEmailSendout: state.asqSurveyResultsParentEmailSendout,
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    onClickNotes: (qId, qNumber, hasNotes) => {
      dispatch(showQuestionNotesModal(qId, qNumber, hasNotes))
    },
    onQuestionInfo: (qId) => {
      dispatch(showPlayerQuestionModal(qId))
    },
    onDownloadASQReport: (id, meta={}) => {
      dispatch(downloadASQReport(id, { ...meta, id }));
    },
    onEnqueueAsqSurveyResultsParentEmailSendout: (id) => {
      dispatch(enqueueAsqSurveyResultsParentEmailSendout(id));
    },
    onSurveyChange: (selectedOption) => {
      const state = ownProps.locationFrom ? { from: ownProps.locationFrom } : {};
      const id = selectedOption && selectedOption.value;
      dispatch(push({
        pathname: linkWithParams('player', { player_id: ownProps.playerId, id }),
        state,
      }));
    },
  }
}

const PlayerSurveyContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(PlayerSurvey)

export default PlayerSurveyContainer;
